import { getTimeZoneOffset } from 'owa-datetime-store';
import EndDateRecurrence from 'owa-service/lib/contract/EndDateRecurrence';
import ExchangeRecurrenceBundle from 'owa-addins-recurrence/lib/schema/ExchangeRecurrenceBundle';
import SeriesTime from 'owa-addins-recurrence/lib/schema/SeriesTime';

const MinutesInHour = 60;
const MillisecondsInMinute = 60 * 1000;

export default function createSeriesTime(bundle: ExchangeRecurrenceBundle): SeriesTime {
    const { startTime, endTime, recurrenceType, timeZone } = bundle;
    const startDate = convertDateStringToNumbers(recurrenceType.RecurrenceRange.StartDate);
    const durationMin = (endTime.getTime() - startTime.getTime()) / MillisecondsInMinute;
    const startTimeMin =
        startTime.getUTCHours() * MinutesInHour +
        startTime.getUTCMinutes() +
        getTimeZoneOffset(startTime, timeZone);

    let seriesTime: SeriesTime = {
        startYear: startDate.year,
        startMonth: startDate.month,
        startDay: startDate.day,
        startTimeMin,
        durationMin,
    };

    if ((recurrenceType.RecurrenceRange as EndDateRecurrence).EndDate) {
        const range = recurrenceType.RecurrenceRange as EndDateRecurrence;
        const endDate = convertDateStringToNumbers(range.EndDate);
        seriesTime = {
            ...seriesTime,
            endDay: endDate.day,
            endMonth: endDate.month,
            endYear: endDate.year,
        };
    } else {
        seriesTime.noEndDate = true;
    }

    return seriesTime;
}

function convertDateStringToNumbers(
    dateString: string
): { day: number; month: number; year: number } {
    const parts = dateString.split('-');
    return {
        year: parseInt(parts[0]),
        month: parseInt(parts[1]),
        day: parseInt(parts[2]),
    };
}
